export function environmentOfOnboarding(onboardingUrl) {
  return {
    importUsersUrl: onboardingUrl,
    companiesUrl: `${onboardingUrl}/organizations.json`,
    organizationsUrl: `${onboardingUrl}/organizations/`,
    onboardingTokenUrl: `${onboardingUrl}/token.json`,
    departmentsUrl: 'departments.json',
    contactsUrl: 'contacts.json',
    usersUrl: `${onboardingUrl}/users`,
    bankingInfoUrl: 'organization_setups/banking_informations.json',
    rpAccountsUrl: 'organization_setups/rp_accounts.json',
    payrollSchedulesUrl: 'organization_setups/payroll_schedules.json',
    ehtUrl: 'organization_setups/ehts.json',
    wcbUrl: 'organization_setups/wcb_details.json',
    vacationsUrl: 'vacations.json',
    signUpUrl: `${onboardingUrl}/users.json`,
    userInfoUrl: `${onboardingUrl}/users/info.json`,
    companyInfoUrl: 'organization_setups/company_informations.json',
    businessConsentFormUrl: `${onboardingUrl}/templates/business_consent_form.pdf`,
    remittanceVerificationUrl: `${onboardingUrl}/templates/remittance_verification_form.pdf`,
    userTemplateUrl: `${onboardingUrl}/templates/contacts.csv`,
    departmentTemplateUrl: `${onboardingUrl}/templates/departments.csv`,
    positionsTemplateUrl: `${onboardingUrl}/templates/positions.csv`,
    adminDashboardUrl: `${onboardingUrl}/admin/dashboard.json`,
    archiveOrgUrl: `${onboardingUrl}/admin/archive_organization`,
    remandOrgUrl: `${onboardingUrl}/admin/remand_organization/`,
    deleteOrgUrl: `${onboardingUrl}/admin/delete_organization`,
    onboardingUrl: '/#/onboarding/companies',
    createCompanyUrl: `${onboardingUrl}/users/create_company.json`,
    confirmationTokenUrl: `${onboardingUrl}/users/confirmation.json?confirmation_token=`,
    resetPasswordUrl: `${onboardingUrl}/users/password.json`,
    attemptUrl: `${onboardingUrl}/users/attempt.json`,
    csvUrl: `${onboardingUrl}/admin/export_organization_as_zip`
  }
};



// WEBPACK FOOTER //
// ./src/environments/apps/onboarding.ts